import { call, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

import * as apiCommon from '../../services/apiCommon';
import * as sagaCommon from '../sagasCommon';
import * as apiPromotion from '../../services/promotion/api_promotion';

import { PROMOTION } from '../../constants/constant_doc_types';
import {
  DELETE_PROMOTION,
  FETCH_LIST_PROMOTION,
  FETCH_PROMOTION_FOR_EDIT,
  SAVE_PROMOTION,
} from '../../constants/constant_saga_types';
import { getLocalDatetime } from '../../utils/local_date';

/**
 * FETCH_LIST_PROMOTION -> callFetchListPromotion
 *
 * @param {*} feathersApp
 */
export function* fetchListPromotionSaga(feathersApp) {
  yield takeLatest(FETCH_LIST_PROMOTION, callFetchListPromotion, feathersApp);
}

function* callFetchListPromotion(feathersApp, action) {
  const { silent, filters } = action;
  yield sagaCommon.showProgressListTable(silent);
  try {
    const { available_from, available_to } = filters;
    const dataParams = {
      filters: {
        ...filters,
        available_from: getLocalDatetime(available_from),
        available_to: getLocalDatetime(available_to),
      },
      list_type: PROMOTION,
    };
    const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
    yield call(sagaCommon.doneListTable, {
      rows: tableData.data,
      total_rows: tableData.total,
    });
  } catch (error) {
    yield sagaCommon.showErrorListTable(error);
  }
}

/**
 * FETCH_PROMOTION_FOR_EDIT -> callFetchPromotionForEdit
 *
 * @param {*} feathersApp
 */
export function* fetchPromotionForEditSaga(feathersApp) {
  yield takeEvery(
    FETCH_PROMOTION_FOR_EDIT,
    callFetchPromotionForEdit,
    feathersApp,
  );
}

function* callFetchPromotionForEdit(feathersApp, action) {
  const { tenant, user } = yield select();
  const { id, silent } = action;
  try {
    if (id) {
      yield sagaCommon.showProgressDataById(silent);
      const fetchParams = { tenant, user, id };
      const doc = yield call(
        apiPromotion.fetchPromotionById,
        feathersApp,
        fetchParams,
      );
      yield sagaCommon.doneDataById(doc);
    }
  } catch (error) {
    yield sagaCommon.showErrorDataById(error);
  }
}

/**
 * SAVE_PROMOTION -> callSavePromotion
 *
 * @param {*} feathersApp
 */
export function* savePromotionSaga(feathersApp) {
  yield takeEvery(SAVE_PROMOTION, callSavePromotion, feathersApp);
}

function* callSavePromotion(feathersApp, action) {
  const { data, silent } = action;
  try {
    yield sagaCommon.showProgressSaveRecord(silent);
    const { tenant, user } = yield select();
    const result = yield call(apiPromotion.savePromotion, feathersApp, {
      tenant,
      user,
      data,
    });
    yield callFetchPromotionForEdit(feathersApp, {
      id: result.id,
      silent: true,
    });
    browserHistory.push(`/admin/promotion/edit/${result.id}`);
    yield sagaCommon.doneSaveRecord(result, 'Promotion was saved');
  } catch (error) {
    yield sagaCommon.showErrorSaveRecord(error);
  }
}

/**
 * DELETE_PROMOTION -> callDeletePromotion
 *
 * @param {*} feathersApp
 */
export function* deletePromotionSaga(feathersApp) {
  yield takeEvery(DELETE_PROMOTION, callDeletePromotion, feathersApp);
}

function* callDeletePromotion(feathersApp, action) {
  yield sagaCommon.showProgressDeleteRecord();
  try {
    const { id } = action;
    let result = null;
    if (id) {
      const { tenant, user } = yield select();
      const { id } = action;
      const params = { tenant, user, id };
      result = yield call(apiPromotion.deletePromotion, feathersApp, params);
      if(result) {
        browserHistory.push('/admin/promotion');
      }
    }
    yield sagaCommon.doneDeleteRecord(id, PROMOTION);
    return result;
  } catch (error) {
    yield sagaCommon.showErrorDeleteRecord(error);
  }
}
